import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

export const env = createEnv({
  server: {
    E2E_BASE_URL: z.string().optional(),
    CI: z.string().optional(),
    ANALYZE: z.enum(['true', 'false']).optional(),
  },
  client: {
    NEXT_PUBLIC_ROOT_URL: z.string(),
    NEXT_PUBLIC_APP_URL: z.string(),
    NEXT_PUBLIC_ENV: z.enum(['LOCAL', 'PRE', 'PRO']),
    NEXT_PUBLIC_CLIENT_ID: z.string(),
    NEXT_PUBLIC_SENTRY_DSN: z.string().optional(),
    NEXT_PUBLIC_SENTRY_ENVIRONMENT: z.string(),
    NEXT_PUBLIC_SAS_TOKEN: z.string().optional(),
    NEXT_PUBLIC_SAS_TOKEN_HISTORICAL: z.string().optional(),
    NEXT_PUBLIC_OPTIMIZELY_SDK_KEY: z.string(),
    NEXT_PUBLIC_FEATURE_PRODUCT_ENRICHMENT: z
      .enum(['true', 'false'])
      .optional(),
    NEXT_PUBLIC_PREVIEW_MODE: z.enum(['true', 'false']).optional(),
    NEXT_PUBLIC_BASE_URL: z.string().optional(),
    NEXT_PUBLIC_TURNSTILE_SITE_KEY: z.string().optional(),
    NEXT_PUBLIC_MARKETS: z.string().optional(),
  },
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    // urls for api calls
    NEXT_PUBLIC_ROOT_URL: process.env.NEXT_PUBLIC_ROOT_URL,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    // auth variables
    NEXT_PUBLIC_CLIENT_ID: process.env.NEXT_PUBLIC_CLIENT_ID,
    // sentry
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_SENTRY_ENVIRONMENT: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
    // optimizely
    NEXT_PUBLIC_OPTIMIZELY_SDK_KEY: process.env.NEXT_PUBLIC_OPTIMIZELY_SDK_KEY,
    // e2e testing
    E2E_BASE_URL: process.env.E2E_BASE_URL,
    CI: process.env.CI,
    // bundle analyzer
    ANALYZE: process.env.ANALYZE,
    // sas images
    NEXT_PUBLIC_SAS_TOKEN: process.env.NEXT_PUBLIC_SAS_TOKEN,
    NEXT_PUBLIC_SAS_TOKEN_HISTORICAL:
      process.env.NEXT_PUBLIC_SAS_TOKEN_HISTORICAL,
    // product enrichment flag
    NEXT_PUBLIC_FEATURE_PRODUCT_ENRICHMENT:
      process.env.NEXT_PUBLIC_FEATURE_PRODUCT_ENRICHMENT,
    // mock ikea wrapper
    NEXT_PUBLIC_PREVIEW_MODE: process.env.NEXT_PUBLIC_PREVIEW_MODE,
    // turnstile
    NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
    // market filtering for regional builds (e.g. "cn-en,cn-zh")
    NEXT_PUBLIC_MARKETS: process.env.NEXT_PUBLIC_MARKETS,
  },
})
